export enum EventMgntModuleApiSuffixModels {
    STACK_CONFIG = 'stack-config',
    SHORTCUT_F1 = 'F1',
    SHORTCUT_F2 = 'F2',
    SHORTCUT_F3 = 'F3',
    SHORTCUT_F4 = 'F4',
    SHORTCUT_F5 = 'F5',
    SHORTCUT_F6 = 'F6',
    SHORTCUT_F7 = 'F7',
    SHORTCUT_F8 = 'F8',
    SHORTCUT_F9 = 'F9',
    SHORTCUT_F10 = 'F10',
    SHORTCUT_F11 = 'F11',
    SHORTCUT_F12 = 'F12',
    SHORTCUT_ENTER = 'Enter',
    SHORTCUT_HOME = 'Home',
    SHORTCUT_END = 'End',
    SHORTCUT_ESC = 'esc',
    SHORTCUT_CTRL_V = 'ctrl + v',
    SHORTCUT_CTRL_F = 'ctrl + f',
    SHORTCUT_CTRL_S = 'ctrl + s',
    SHORTCUT_CTRL_A = 'ctrl + a',
    SHORTCUT_CTRL_O = 'ctrl + o',
    SHORTCUT_CTRL_H = 'ctrl + h',
    SHORTCUT_CTRL_G = 'ctrl + g',
    SHORTCUT_CTRL_R = 'ctrl + r',
    SHORTCUT_CTRL_M = 'ctrl + m',
    SHORTCUT_CTRL_U = 'ctrl + u',
    SHORTCUT_CTRL_Q = 'ctrl + q',
    DIVISION_LIST = 'ux/division',
    MAIN_AREA_LIST = 'ux/main-area',
    STACK_AREA_CONFIG = 'stack-area-config',
    UX_DIVISION = 'ux/division',
    UX_NAMED_STACK_CONFIG = 'ux/named-stack-config',
    UX_CUSTOMER_TYPE = 'ux/customer-type',
    UX_ALARM_GROUP = 'ux/alarm-group',
    STACK_AREAS = 'stack-area-config',
    VEHICLE_REGISTRATION = 'vehicle-registration',
    UX_PTT_REGISTRATIONS = 'ux/ptt-registrations',
    UX_PDA_REGISTRATIONS = 'ux/pda-registrations',
    UX_PTT_UNOCCUPIED = 'ux/ptt-unoccupied',
    UX_PDA_UNOCCUPIED = 'ux/pda-unoccupied',
    PTT_REGISTRATION = 'ptt-registrations',
    NAMED_STACK_CONFIG = 'named-stack-config',
    PDA_REGISTRATION = 'pda-registrations',
    BOUNDARY_LIMIT = 'boundary-limit',
    DELAY_DURATION = 'delay-duration',
    ALARM_GROUP = 'alarm-group',
    ALARM_TYPE = 'alarm-type',
    SAFE_ENTRY_LIMIT = 'safe-entry-limit',
    RO_ACCEPT_TIME = 'ro-accept-time',
    SIGNAL_AUTOMATION = 'signal-automation',
    UX_ALARM_TYPE = 'ux/alarm-type',
    CMS_SMS_GROUP = 'cmc-sms-group',
    POST_INCIDENT_PATROL = 'post-incident-patrol',
    CLUSTER_CONFIGURATION = 'cluster-configuration',
    VEHICLE_CATEGORY = 'ux/vehicle-category',
    SUB_AREA = 'ux/sub-area-cluster-config',
    EVENT_TYPE = 'event-types',
    CLUSTER_CONFIG_SUB_AREA = 'cluster-config-sub-area',
    CMC_SMS_GROUP_EMPLOYEE = 'cmc-sms-group-employee',
    BOLO_DISTANCE = 'bolo-distance',
    UX_BRANCH = 'ux/branch',
    UX_BRANCH_DIVISION = 'ux/branch-division',
    SHIFT_CHANGE_WAY_POINT = "shift-change-way-point",
    DISPATCH_MODE = 'ux/dispatch-mode',
    SUSPEND_DELAY = 'max-suspend-delay',
    ACTIVE_PATROL_MESSAGE = 'active-patrol-message',
    THIRD_PARTY_DETAILS = 'third-party-details',
    GET_ADDRESS_FROM_AFRIGIS = 'afrigis/ux/address',
    POST_SELECTED_ADDRESS = 'afrigis/address/details',
    DISTRIBUTION_GROUP = 'distribution-group',
    DISTRUBUTION_GROUP_EMPLOYEE = 'distribution-group-employee',
    NAMED_STACK_MAPPING = 'named-stack-mapping',
    UX_NAMED_STCK_CONFIGDIVISION = 'ux-named-stack-configdivision',
    DELAY_DISPATCH = 'delay-dispatch',
    CUSTOMER_ADDRESS = 'customer-address',
    COMMUNITY_PATROL = 'community-patrol',
    FINDU_DISPATCH = 'findu-dispatch',
    DISPATCH_EXCEPTION = 'dispatch-exception',
    FEEDBACK_OFFSITE = 'feedback-Offsite',
    ALARM_TYPE_CONFIG = 'alarm-type-config',
    PROACTIVE_PATROL = 'proactive-patrol',
    PROACTIVE_PATROL_TYPE = 'proactive-patrol-type',
    INCIDENT = 'incident',
    INCIDENT_TYPES = 'incident-types',
    EVENT_TYPES_ACTIVE_ONLY = 'event-types-active-only',
    DECLINE_SETUP = 'decline-setup',
    DECLINE_SETUP_REASON = 'deline-setup-reason',
    ALARM_TYPE_CONFIG_LIST = 'ux/alarm-type-description',
    PROPERTY_ACCESS = 'property-access',
    CMC_FEEDBACK = 'cmc-feedback',
    UX_CMC_FEEDBACK_STANDBY_ITEMS = 'ux/cmc-feedback-standby-items',
    CUSTOMER_ADDRESS_DIVISION = 'customer-address-division-list',
    // UX_CMC_FEEDBACK_STANDBY_ITEMS = 'ux/check-list',
    CHECK_LIST = 'check-list',
    UX_CHECK_LIST_OPTION = 'ux/check-list-option',
    SAFETY_ALERT = 'safety-alert-config',
    VAS_CONFIG = 'vas-config',
    UX_ALARM_TYPE_DESCRIPTION = 'ux/alarm-type-description',
    UX_VAS_CONFIG_DAY = 'ux/vas-config-day',
    VAS_CONFIG_ALARM_TYPE = 'vas-config-alarm-type',
    VAS_CONFIG_TIME_DELAY = 'vas-config-time-delay',
    TIME_ON_SITE = 'time-on-site',
    TIME_ON_SITE_MAIN_AREA = 'time-on-site-main-area',
    SAFETY_ALERT_CONFIG_MAIN_AREA = 'safety-alert-config-main-area',
    RO_COMMUNITY_PATROL = 'ro-community-patrol',
    RO_COMMUNITY_PATROL_TYPES = 'ro-community-patrol-types',
    PROPERTY_ACCESS_REASON = 'property-access-reason',
    STATS_CONFIG = 'stats-config',
    EVENT_TYPE_LIST = 'ux/event-types',
    SIGNAL_MANAGEMENT_CONFIG = 'signal-management-config',
    SIGNAL_MANAGEMENT_RESOLUTION_CONFIG = 'signal-management-resolution-config',
    SIGNAL_MANAGEMENT_ERB_THRESHOLD_CONFIG = 'signal-management-erb-threshold-config',
    SALES_API_VEHICLE_SEARCH = 'ux/vehicles/search',
    SIGNAL_MANAGEMENT_WORK_LIST = 'overactive-report-worklist',
    SIGNAL_MANAGEMENT_TECH_CALLS = 'signal-managment-tech-calls',
    SIGNAL_SUB_AREA = 'ux/sub-area',
    SIGNAL_MANAGEMENT_WORK_LIST_MONTHS = 'overactive-report-worklist/months',
    COORDINATOR_DEFAULT_AREA = 'coordinator-default-area',
    UX_TECH_AREA = 'ux/tech-area',
    UX_MAIN_AREA_ALL = 'ux/main-area/all',
    DROPDOWN_CONFIG = 'signal-management-dropdown-config',
    DROPDOWN_CONFIGURATION = 'signal-management/dropdown-configuration',
    REPORTING_CONFIG = 'reporting-config',
    STACK_WINELANDS_STACK_AREA_CONFIG = 'ux/stack-area-config',
    STACK_WINELANDS_STACK_CONFIG = 'ux/stack-config',
    PHONE_STACK_VIEW = 'phoner-stack-view',
    DISPATCHER_STACK_VIEW = 'dispatcher-stack-view',
    UX_BRANCHES = 'ux/branches',
    OCCURRENCE_BOOK_DISPATCHER = "occurrence-book-dispatcher",
    OCCURRENCE_BOOK_SIGNAL = 'occurrence-book-signal',

    OCCURRENCE_BOOK_REQUEST_VEHICLE = 'occurrence-book/request-vehicle',
    OCCURRENCE_BOOK_REQUEST_DISPATCH = "occurrence-book/request-dispatch",
    DESPATCH_VIEW_RO = "dispatcher-view-response-officer",
    OCCURRENCE_BOOK_RO_VEHICLE_ALLOCATED = "occurrence-book-response-officer-vehicles/allocated",
    OCCURRENCE_BOOK_RO_VEHICLE_CANCELLED = "occurrence-book-response-officer-vehicles/cancelled",
    UX_CLUSTER_CONFIG = "ux/cluster-configuration",
    UX_SUB_AREA = "ux/sub-area",
    UX_VEHICLE_CATEGORY = "ux/vehicle-category",
    UX_RO_VEHICLE_STATUS = "ux/response-officer-vehicle-status",
    UX_DISPATCH_MODE = "ux/dispatch-mode",
    RESPONSE_OFFICER_BREAK_APPROVED = "response-officer-break/approved",
    RESPONSE_OFFICER_BREAK_DECLINED = "response-officer-break/declined",
    CLASSIFY_INCIDENT = "incident-types",
    UX_FEEDBACK_MESSAGE = "ux/feedback-message",
    FEEDBACK_MESSAGE = "feedback-message",
    OCCURRENCE_BOOK_FEEDBACK_MESSAGE = "occurrence-book-feedback-message",
    OCCURRENCE_BOOK_INCIDENT_TYPE = "occurrence-book-incident-type",
    OCCURANCE_BOOK_LOGAWAY = 'occurrence-book/logaway',
    KEY_HOLDER = 'ux/key-holder',
    KEY_HOLDER_PASSWORD = 'key-holder/password',
    CUSTOMER_ADDRESS_PASSWORD = "customer-address/password",
    CUSTOMER_ADDRESS_PASSWORD_VALIDATE = 'customer-address/password-validate',
    OCCURANCE_BOOK_ACKNOWLEGED = 'occurrence-book-acknowledged',
    OCCURANCE_BOOK_ACKNOWLEGED_PASSWORD = 'occurrence-book/acknowledgement/incorrect-password',
    OCCURANCE_BOOK_CANCEL_DISPATCH = 'occurrence-book-response-officer-vehicles/occurrence-book/cancelled',
    OCCURANCE_BOOK_EVENT_MEMO = 'occurrence-book-event-memo',
    OCCURANCE_BOOK_RESPONSE_OFFICER_VEHICLE_OB = 'occurrence-book-response-officer-vehicle/ob',
    RESPONSE_OFFICER_CHAT_OCCURANCE_BOOK = "response-officer-chat/occurrence-book",
    DEVICE_STATUS = 'response-officer-current-log',
    CUSTOMER_SIGNAL_ACTION_ARRIVAL = 'customer-signal/action-arrival',
    CUSTOMER_SIGNAL_ACTION = 'customer-signal/action',
    CUSTOMER_SIGNAL_ARRIVAL = 'customer-signal/arrival',
    CUSTOMER_SIGNAL_MONTHS = 'customer-signal/months',
    CUSTOMER_SIGNAL_DAY_NIGHT = 'customer-signal/day-night',
    CUSTOMER_SIGNAL_ACTION_HOURS = 'customer-signal/action-hours',
    CUSTOMER_SIGNAL_ACTION_DURATION = 'customer-signal/hour-duration',
    CUSTOMER_DEBTOR_LIST = 'customer-debtors/address',
    PAYMENT_OVERRIDE = 'payment-override',
    PAYMENT_UNDERRIDE = 'payment-underride',
    USEFUL_NUMBER = 'useful-number',
    USEFUL_NUMBER_CONTACT = 'useful-number-contact',
    LONG_STANDOFF = 'long-stand-off',
    LONG_STANDOFF_MAIN_AREA = 'long-stand-off-main-area',
    INVOICE_INFO = 'customer-invoice',
    OPEN_CLOSING_SETUP = 'open-close-setup',
    ALARM_TYPE_WITH_DESCRIPTION = 'ux/alarm-type-with-description',
    OPEN_CLOSING_SETUP_ARM = 'open-close-setup-arm',
    OPEN_CLOSING_SETUP_DISARM = 'open-close-setup-disarm',
    KEY_HOLDER_OCCERENCE_BOOK = 'key-holder/occurrence-book',
    RESPONSE_INSTRUCTION = 'response-instruction',
    OCCURANCE_BOOK_SIGNAL_DIVISION = 'occurrence-book-signal/division',
    OCCURANCE_BOOK_SIGNAL_REPORT = 'occurrence-book-signal/report',
    OCCURANCE_BOOK_EVENT_MEMO_REPORT = 'occurrence-book-event-memo/report',
    UX_USEFUL_NUMBER = 'ux/useful-number',
    OCCURANCE_BOOK_ALARM = "occurrence-book-alarm",
    OCCURANCE_BOOK_ALARM_INFO = 'occurrence-book-alarm/info',
    OCCURANCE_BOOK_SIGNAL_INFO = 'occurrence-book-signal-info',
    OCCURANCE_BOOK_RO_INFO = 'response-officer-chat/occurrence-book',
    CUSTOMER_PREFERENCE_CUSTOMER_CUSTOM_CALL_FLOW = 'customer-preference-customer-custom-call-flow',
    CUSTOMER_PREFERENCE_SITE_CUSTOM_CALL_FLOW = 'customer-preference-site-custom-call-flow',
    CUSTOMER_PREFERENCE_SITE_DISPATCH_FLOW = 'customer-preference-site-dispatch-flow',
    CUSTOMER_PREFERENCE_CUSTOMER_DISPATCH_FLOW = 'customer-preference-customer-dispatch-flow',
    DAYS = 'ux/day',
    KEY_HOLDER_CUSTOMER_CUSTOM_CALL_FLOW = 'key-holder/customer-custom-call-flow',
    CALL_FLOW_PHONER = 'occurrence-book-call-flow/occurrence-book',
    KEY_HOLDER_CLIENT_TESTING_CUSTOMER_CUSTOM_CALL_FLOW = 'key-holder/client-testing-customer-custom-call-flow',
    CUSTOMER_PREFERENCE = 'customer-preference',
    CUSTOMER_PREFERENCE_CUSTOMER_ADDRESS = 'customer-preference-customer-address',
    KEYHOLDER_SITE_CUSTOM_CALL_FLOW = 'key-holder/site-custom-call-flow',
    CUSTOMER_KEY_HOLDER = "ux/key-holder/customer-address",
    CUSTOMER_KEY_HOLDER_ID = "key-holder/id",
    CUSTOMER_PATROL_HISTORY = "patrol-history",
    UX_STACK_CONFIG = 'ux/stack-config',
    CCTV_POINTS = 'cctv-points',
    CCTV_POINTS_CAMERA_TYPE = 'ux/cctv-points-camera-type',
    OCCURRENCE_BOOK_PHONEIN = 'occurrence-book-phonein',
    OCCURRENCE_BOOK_MEDICAL_PHONEIN = 'occurrence-book-medical-phonein',
    OCCURRENCE_BOOK_MEDICAL = 'occurrence-book-medical',
    UX_SEVERITY = 'ux/Severity',
    OCCURRENCE_BOOK_FIRE_PHONEIN = 'occurrence-book-fire-phonein',
    OCCURRENCE_BOOK_FIRE = 'occurrence-book-fire',
    MOVE_TO_STACK = 'occurrence-book/id',
    OCCURANCE_BOOK = 'occurrence-book',
    OCCURANCE_SIGNALS = "occurrence-book-signal/customer-address",
    OCCURENCE_KEY_HOLDER = "ux/key-holder/occurrence-book",
    THIRD_PARTY_TYPES = 'ux/third-party-types',
    SPECIAL_INSTRUCTION_OCCURANCE_BOOK = 'special-instruction/occurrence-book',
    ARM_DISARM_SCHEDULE = 'arm-disarm-schedule/occurrence-book',
    CLIENT_TESTING = 'client-testing',
    TECHNICIAN_TESTING = 'technical-testing',
    TECHNICIAN_TESTING_OTHER = 'technical-testing',
    EMPLOYEE = 'employee',
    TECHNICIAN_TESTING_VERIFY_PASSWORD = 'technical-testing/verify-password',
    UX_THIRD_PARTY_DETAILS = 'ux/third-party-details',
    OCCURRENCE_BOOK_THIRD_PARTY_MONITORING = 'occurrence-book-third-party-monitoring',
    OCCURRENCE_BOOK_COMMUNITY_CCTV = 'occurrence-book-community-cctv',
    OCCURRENCE_BOOK_COMMUNITY_MEDICAL = 'occurrence-book-community-medical',
    OCCURRENCE_BOOK_COMMUNITY_FIRE = 'occurrence-book-community-fire',
    UX_VEHICLE_MODEL = 'ux/vehicle-model',
    UX_VEHICLE_MAKE = 'ux/vehicle-make',
    UX_VEHICLE_COLOR = 'ux/vehicle-color',
    UX_CAMERA_POINT = 'ux/cctv-points',
    OCCURANCE_BOOK_SIGNAL_CUSTOMER_ADDRESS = 'occurrence-book-signal/customer-address',
    OCCURRENCE_BOOK_COMMUNITY_PHONEIN = 'occurrence-book-community-phonein',
    UX_PHONEIN_FEEDBACK = 'ux/phone-in-feedback',
    UX_REQUEST_TYPE = 'ux/request-type',
    OCCURRENCE_BOOK_SOCIAL_RESPONSIBILITY = 'occurrence-book-social-responsibility',
    OCCURRENCE_BOOK_AUTOMOBILE_ASSISTANCE = 'occurrence-book-automobile-assistance',
    OCCURRENCE_BOOK_CONTROLLER = 'occurrence-book/controller',
    OCCURRENCE_BOOK_SIGNAL_OCCURRENCE_BOOK = 'occurrence-book-signal/occurrence-book',
    OCCURANCE_BOOK_SIGNAL_ID = 'occurrence-book-signal/id',
    OPEN_AREA_SETUP = 'open-area-setup',
    DEFULAT_MESSAGE_CONFIG = 'default-message',
    UX_DEFULAT_MESSAGE_TYPE = 'ux/defaultMessageType',
    OCCURRENCE_BOOK_RESPONSE_OFFICER_VEHICLE_DISPATCHED_OR_LIST = 'occurrence-book-response-officer-vehicle/dispatched-ro-list',
    OCCURRENCE_BOOK_RESPONSE_OFFICER_VEHICLES_ARRIVED = 'occurrence-book-response-officer-vehicles/arrived',
    SHOTS_FIRED_CLIENT = 'shots-fired/client',
    SHOTS_FIRED_HUB = 'shots-fired/hub',
    DISPATCHER_VIEW_SUB_AREA = 'dispatcher-view-sub-area',
    OPEN_AREAS = 'open-areas',
    UX_OPEN_AREA_SETUP = 'ux/open-area-setup',
    UX_SIGNAL_TESTING_DURATION = 'ux/signal-testing-duration',
    ZONE_EQUIPMENT_MAPPING = 'zone-equipment-mapping',
    UX_OWNERSHIP_TYPES = 'ux/OwnerShip-Types',
    NOTIFIED_BODY_NUMBER_CUSTOMER_ADDRESS = 'notified-body-number/customer-address',
    NOTIFIED_BODY_NUMBER_OCCURRENCE_BOOK = 'notified-body-number/occurrence-book',
    SIGNAL_SPECIALS = 'Signal-specials',
    TECHNICAL_TESTING_RESET_PASSWORD = 'technical-testing/reset-password',
    UX_SIGNAL_SPECIALS = 'ux/Signal-specials',
    UX_SIGNAL_ALARM_TYPE_SPECIAL_SIGNALS = 'ux/SignalAlaramType/Signal-specials',
    UX_TRANSMITTER = 'ux/TransmitterCodeDropdown/Signal-specials',
    UX_ACTUAL_INFO = 'ux/SetNameTypeDropdown/Signal-specials',
    DECODER_CONFIG = 'decoder-configs',
    UX_DECODERS = 'ux/decoders',
    UX_OLD_DECODERS = 'ux/old-decoders',
    UX_SETNAME = 'ux/set-names',
    UX_SETNAME_DECODERS = 'ux/setnames/decoder',
    DECODER_CONFIG_CUSTOMER_DECODER = 'decoder-config/customer-decoder',
    DECODER = 'decoder',
    KEY_HOLDER_PASSEORD_VALIDATE = 'key-holder/password-validate',
    RESPONSE_OFFICER_TIME_ONSITE_TIME_EXTENSION = 'response-officer-time-onsite/time-extension',
    ARM_DISARM_SCHEDULE_CUSTOMER_ADDRESS = 'arm-disarm-schedule/customer-address',
    ARM_DISARM_SCHEDULE_OCCURENCE_BOOK = 'arm-disarm-reschedule/occurrence-book',
    OCCURANCE_BOOK_MOVE = 'occurrence-book/move',
    OCCURANCE_BOOK_ONHOLD = 'occurrence-book/onhold',
    OCCURANCE_BOOK_UNHOLD = 'occurrence-book/unhold',
    CUSTOM_CATEGORY_GROUP = 'custom-category-group',
    CUSTOM_CATEGORY_LIST = 'custom-category-list',
    CUSTOM_CATEGORY_CONFIG = 'custom-category-config',
    UX_CUSTOM_CATEGORY_LIST = 'ux/custom-category-list',
    UX_CUSTOM_CATEGORY_LIST_ITEM = 'ux/custom-category-list-item',
    UX_CUSTOM_MODULES = 'ux/custom-modules',
    UX_CUSTOM_CATEGORY_GROUP = 'ux/custom-category-group',
    UX_CUSTOM_FIELD_FORMATS = 'ux/custom-field-formats',
    UX_CUSTOM_FIELD_TYPE = 'ux/custom-field-type',
    UX_CUSTOM_LETTER_CASES = 'ux/custom-letter-cases',
    OCCURRENCE_BOOK_PRIORITIZATION_MANUAL = 'occurrence-book/prioritization/manual',
    PRIORITIZATION_DISPACHE = 'occurrence-book-prioritize-dispatch',
    OCCURRENCE_BOOK_ACKNOWLEDGEMENT_GENERAL = 'occurrence-book/acknowledgement/general',
    OCCURRENCE_BOOK_ACKNOWLEDGEMENT_HOLIDAY_INSTRUCTION = 'occurrence-book/acknowledgement/holiday-instruction',
    OCCURRENCE_BOOK_ACKNOWLEDGEMENT_RESPONSE_INSTRUCTION = 'occurrence-book/acknowledgement/response-instruction',
    OCCURRENCE_BOOK_ACKNOWLEDGEMENT_PHONER_INSTRUCTION = 'occurrence-book/acknowledgement/phoner-instruction',
    ACTION_ARRIVAL_MONTHS = 'action-arrival/months',
    ACTION_ARRIVAL = 'action-arrival',
    CUSTOMER_ADDRESS_ACTION_ARRIVAL = 'customer-address/action-arrival',
    STACK_MONITORING_SUPPERVISOR_VIEW = 'stack-monitoring/supervisor-view',
    STACK_MONITORING_SUPPERVISOR_VIEW_DETAILS = 'stack-monitoring/supervisor-view-details',
    CLIENT_REQUEST_TYPE = 'client-request-type',
    SIGNAL_MANAGEMENT_THIRD_PARTY_CONFIG = 'signal-management/third-party-config',
    STACK_DISTRIBUTION_OPERATOR = 'stack-distribution/operator',
    STACK_DISTRIBUTION = 'stack-distribution',
    UX_STAFF_TYPE = 'ux/staff-type',
    UX_STACK_AREA_CONFIG = 'ux/stack-area-config',
    SUPERVISOR_VIEW_OPERATOR_KEYHOLDER_PASSWORD = 'stack-monitoring/supervisor-view/operator-keyholder-password',
    STAFF_MANITORING_LOGGED_IN_VIEW = 'stack-monitoring/supervisor-loggedin-view',
    STACK_MONITORING_SUPPERVISOR_VIEW_OPERATOR_KEYHOLDER_PASSWORD = 'stack-monitoring/supervisor-view/operator-keyholder-password/details',
    STACK_MONITORING_SUPPERVISOR_VIEW_OPERATOR = 'stack-monitoring/supervisor-view/operator',
    OPERATOR = 'operator',
    OPERATOR_INTERACTION_SUPERVISOR_VIEW = 'operator-interaction/supervisor-view',
    DECODER_ACCOUNT_CONFIGURATIONS = 'decoder-account-configurations',
    UX_COMMSTYPES = 'ux/CommsTypes',
    UX_CLIENT_REQUEST_TYPE = 'ux/client-request-type',
    SUPERVISOR_REQUEST = 'supervisor-request',
    SUPERVISOR_MESSAGE = 'supervisor-message',
    SUPERVISOR_NOTIFICATION = 'supervisor-notification',
    CELL_PANIC = 'cell-panic',
    FAIL_TO_TEST = 'fail-to-test',
    CELL_PANIC_CONFIG = 'cell-panic-config',
    SIGNAL_MANAGEMENT_CUSTOMER = 'signal-management-customer',
    SIGNAL_MANAGEMENT_CLIENT_DETAILS = 'overactive-report-worklist/details',
    TECHNICIAN_SIGNAL_MANAGEMENT_DETAILS = 'technician-signal-management/details',
    CANCELLATION_ESCALATION = 'cancellation-escalation',
    SUPERVISOR_REQUEST_OCCURRENCE_BOOK_COMMENTS = 'supervisor-request/occurrence-book/comments',
    WORK_LIST_SIGNAL_LIST = 'overactive-report-worklist-signal-List',
    WORK_LIST_MONTHS = 'overactive-report-worklist/months',
    INTERVENTION_REQUEST = 'intervention-request',
    DISTRICT_MANAGER_INTERVENTION_REQUEST = 'district-manager/intervention-request',
    DISTRICT_MANAGER_CANCELLATION_ESCALATION_REQUEST = 'district-manager/cancellation-esclation-request',
    DISTRICT_MANAGER_ERB_EXCLUSION_REQUEST = 'district-manager/erb-exclusion-request',
    CUSTOMER_ADDRESS_ACTION = 'customer-address/action',
    CUSTOMER_ADDRESS_ARRIVAL = 'customer-address/arrival',

    MANAGER_INTERVENTION_REQUEST = "intervention-request-manager-status",
    MANAGER_CANCELLATION_ESCALATION_REQUEST = "cancellation-escalation-manager-status",

    CUSTOMER_ADDRESS_DAY_NIGHT = 'customer-address/action-arrival-day-night',
    CUSTOMER_ADDRESS_ACTION_HOURS = 'customer-address/action-hourwise',
    CUSTOMER_ADDRESS_ARRIVAL_HOURS = 'customer-address/arrival-hourwise',
    UX_CALL_FEEDBACK_STATUS = 'ux/call-feedback-status',
    UX_CALL_BACK_STATUS = 'ux/call-back-status',
    UX_CALL_CATEGORY = 'ux/call-category',
    UX_FOLLOW_UP_STATUS = 'ux/follow-up-status',
    UX_FOLLOW_UP_REASON = 'ux/follow-up-reason',
    UX_RESOLVED_TELEPHONICALLY_STATUS = 'ux/resolved-telephonically-status',
    COORDINATOR_ACTION_FOLLOW_UP = 'coordinator-action/follow-up',
    COORDINATOR_ACTION_CALL_BACK = 'coordinator-action/call-back',
    COORDINATOR_ACTION_TELEPHONICALLY = 'coordinator-action/resolved-telephonically',
    CUSTOMER_CALL_CUSTOMER_CALL = 'customer-call/customer-call',
    CUSTOMER_CALL_FLOW_FEEDBACK = 'customer-call-flow/customer-call-feedback',
    CUSTOMER_CALL_FLOW = 'customer-call-flow',
    UX_SETNAMES = 'ux/setnames',
    WORK_SUMMARY_COORDINATORS = 'work-summary-coordinators',
    WORK_SUMMARY_DM_ESCALATIONS = 'work-summary-esclations',
    CUSTOMER_KEY_HOLDER_LIST = "key-holder/customer-address",
    UX_RENTAL_ALARM_CONFIG = 'ux/rented-alarm-config',
    UX_PANEL_TYPE_CONFIG = 'ux/panel-type-config',
    QUERY_BUILDER_CONFIG = 'query-builder-config',
    UX_QUERY_BUILDER_TYPE = 'ux/query-builder-type',
    QUERY_BUILDER_TABLE = 'query-builder-table',
    QUERY_BUILDER_CONFIG_TABLE = 'query-builder-config-tables',
    QUERY_BUILDER_CONFIG_TABLE_FIELD = 'query-builder-config-table-fields',
    DECODER_CODE_GENERATION = 'decoder-account-code/generate',
    CUSTOMER_ACCOUNT = 'customer-account',
    CUSTOMER_ACCOUNT_UPDATE = 'customer-account-update',
    UX_OLD_DECODER_ACCOUNT_CONFIG = 'ux/old-decoder-account-configurations',
    UX_DECODER_ACCOUNT_CONFIGURATIONS = 'ux/decoder-account-configurations',
    UX_OLD_ACCOUNT_CODE = 'ux/old-account-code',
    UX_DECODER_CONFIG_STATUS = 'ux/decoder-config-status',
    WORK_LIST_CURRNT_NOTES = 'overactive-report-worklist/current-notes',
    COORDINATOR_VIEW_LIST = 'coordinator-view-list',
    UX_COORDINATOR = 'ux/coordinator',
    GET_OTP = 'otp-payment-override',
    OTP_VERIFY = 'otp',
    ERB_QUERY_BUILDER = 'erb-query-builder',
    ERB_TEMPLATE_TYPE = 'ux/erb-template-type',
    UX_CUSTOM_TABLES = 'ux/custom-table',
    UX_CUSTOM_COLUMN = 'ux/custom-column',

    QUERY_ANALYST = 'signal-management/query-analyst',
    QUERY_ANALYST_UPLOAD = 'signal-management/query-analyst-upload',
    UX_TEMPLATE_DROPDOWN = 'ux/signal-management/query-analyst',
    UX_OPERATOR_DROPDOWN = 'ux/signal-management/query-analyst/operators',
    UX_COLOUMNS_DROPDOWN = 'ux/signal-management/query-analyst/coloumns',
    UX_TABLE_DROPDOWN = 'ux/signal-management/query-analyst/ArchiveAlias',
    QUERY_ANALYST_RUN = 'signal-management/query-analyst/run',
    QUERY_ANALYST_TABLE = 'signal-management/query-analyst/table',
    QUERY_ANALYST_VERIFY = 'signal-management/query-analyst/verify',
    MYTICKET = 'myticket',
    // GET_OTP ='otp-payment-override',
    ERB_EXCLUSION_CONFIG = 'erb-exclusion-config',
    UX_VIEW_ORIGIN_CATEGORIES = 'ux/view-origin-categories',
    UX_VIEW_ORIGIN = 'ux/view-origin',
    UX_SITE_TYPE = 'ux/site-types',
    // GET_OTP ='otp-payment-override'
    BOLO = 'bolo',
    ZONE_SUSPEND = 'zone-suspend',
    ZONE_SUSPEND_MAX_DELAY = 'zone-suspend/Zone-Suspend-MaxDelay',
    CRIME_DOCKET = 'crime-docket',
    CRIME_DOCKET_DRAFT = 'crime-docket/draft',
    CRIME_DOCKET_COMPLETED = 'crime-docket/completed',
    CRIME_DOCKET_PREREQUISITE = 'crime-docket/prerequisite',
    CRIME_DOCKET_Id = 'crime-docket/id',
    CRIME_DOCKET_LIST = 'crime-docket/list',
    CRIME_DOCKET_OCCURENCE_BOOK_NUMBER = 'crime-docket/occurrence-book-number',
    CRIME_DOCKET_PENDING_INDIVIDUAL = 'crime-docket/pending-individual',
    CRIME_DOCKET_OCCURENCE_BOOK = 'crime-docket/occurrence-book',
    CRIME_DOCKET_EXISTING_PROTECTION_CRIME_DOCKET = 'crime-docket/existing-protection/crime-docket',
    CRIME_DOCKET_EXISTING_PROTECTION = 'crime-docket/existing-protection',
    CALL_CATEGORY = 'call-category',
    RESOLUTION_CATEGORY = 'resolution-category',
    FOLLOW_UP_REASON = 'follow-up-reason',
    CRIME_DOCKET_POST_INCIDENT_PR_CALL = 'crime-docket/post-incident-public-relation-call',
    AR_OPEN_AREA = 'ar-open-area',
    UX_AR_OPEN_AREA = 'ux/ar-open-area',

    PATROL_CONFIG = "patrol-config-list",
    PATROL_CONFIG_POST = "patrol-config",
    THIRD_PARTY_ESCALATION = 'third-party-escalation',
    UX_TECHNICAL_TESTING_CONFIG = 'ux/technical-testing-config',
    NKA_LIST = 'nka-list',
    CLIENT_TESTING_OTHER = 'client-testing/other',
    CLIENT_TESTING_MANUALLY_STOPPED_ALL = 'client-testing/manually-stopped-all',
    VISIBILITY_PATROL = "visibility-patrol",
    // VISIBILITY_PATROL_POST ="visibility-patrol",
    UX_PARTITION = 'ux/partition',
    SNAPSHOT_VIEW = 'supervisor-snap-shot-view',
    UX_OPERATOR = 'ux/operator',
    UX_DATA_SOURCE = 'ux/data-source',
    HISTORY_STACK = 'history-stack',
    AR_OPTION_LONG_STAND_OFF = 'ar-option-long-stand-off',
    LOGIN_NON_ARM_RESPONSE = 'login-non-arm-response',
    UX_DECODER_ACCOUNT_CONFIG_CUSTOMER_ADDRESS = 'ux/decoder-account-configurations-customer-address',
    DISPATCHER_MAP_VIEW = 'dispatcher-map-view',
    AUTO_DISPATCH_USAGE = 'auto-dispatch-usage',
    LONG_PHONE = 'long-phone-stats',
    PHONER_STACK_VIEW_EMERGENCY_NON_EMERGENCY_COUNT = 'phoner-stack-view/emergency-non-emergency-count',
    UX_PARTITION_DECODER = 'ux/partition-decoder',
    LOGIN_NON_ARM_RESPONSE_NON_RESPONSE_MANUALLY_LOGGED_IN = 'login-non-arm-response/non-response-manually-logged-in/true',
    FEEDBACK_ADDITIONAL = 'feedback/Additional',
    FEEDBACK_INCIDENT_FEEDBACK_SUMMARY_LIST = 'feedback/IncidentFeedbackSummary/List',
    CALL_ME = 'call-me',
    SHIFT_CHNAGING = 'shift-changing',
    DATA_INTEGRITY_PROCESS_FAILURE = 'data-integrity-process-failure',
    DATA_INTEGRITY_PROCESS_FAILURE_TOTAL = 'data-integrity-process-failure/total',
    CMC_SERVICE_LEVEL_CONFIG = 'cmc-service-level-config',
    FEEDBACK_ROFEEDBACK_ADD = 'feedback/ROFeedback/Add',
    FEEDBACK_INCIDENTFEEDBACK_ADD = 'feedback/IncidentFeedback/Add',
    FEEDBACK_CLIENTFEEDBACK_ADD = 'feedback/ClientFeedbackAdd',
    THIRD_PARTY_FEEDBACK_EXTERNAL_LIST = 'feedback/ThirdPartyFeedback/External/List',
    THIRD_PARTY_FEEDBACK_INTERNAL_LIST = 'feedback/ThirdPartyFeedback/Internal/List',
    THIRD_PARTY_FEEDBACK_ADD = 'feedback/ThirdpartyFeedbackAdd',
    FINISHED_IN_15_NO_PASSWORD = 'data-integrity-process-failure/finished-in-15-no-password',
    FINISHED_IN_15_NO_PASSWORD_COUNT = 'data-integrity-process-failure/finished-in-15-no-password-count',
    RESPONSE_LOGGED_AFTER_CANCE = 'data-integrity-process-failure/response-logged-after-cancel',
    NO_PASSWORD_NO_RESPONSE = 'data-integrity-process-failure/no-password-no-response',
    NO_PASSWORD_NO_RESPONSE_COUNT = 'data-integrity-process-failure/no-password-no-response-count',
    FINSISH_IN_4_MINUTTES = 'data-integrity-process-failure/finished-in-4-minutes',
    FEED_BACK_LIST = 'feedback/List',
    LONG_ARRIVAL_RESPONSE_TH_ONE = 'long-arrival-measure-one',
    LONG_ARRIVAL_RESPONSE_TH_TWO = 'long-arrival-measure-two',
    LONG_ARRIVAL_RESPONSE_TH_THREE = 'long-arrival-measure-three',
    DISPATCHER_MAP_LEGEND = 'dispatcher-map-legend',
    USER_RANKING = 'user-ranking',
    UX_EVENT_TYPES_DESCRIPTION = 'ux/event-types/description',
    SERVICE_MEDIAN = 'service-median',
    SERVICE_MEDIAN_LIST = 'service-median/total',
    ERB_EXCLUSION_REQUEST = 'erb-exlusion-request',
    UX_ERB_EXCLUSION_REASON = 'ux/erb-exclusion-reason',
    SHIFT_STATS = 'shift-stats',
    GATE_ACCESS_OUTGOING_GATE_CALL = 'gate-access/outgoing-gate-call',
    GATE_ACCESS_IMCOMING_GATE_CALL = 'gate-access/incoming-gate-call',
    ERB_EXCLUSION_REASON_CONFIG = 'erb-exclusion-reason-config',
    SERVICE_LEVEL = 'service-level',
    SERVICE_LEVEL_TOTAL = 'service-level/total',
    VOLUME = 'volume-list',
    CREATE_MESSAGE = 'supervisor-alert',
    OPERATOR_HISTORY = 'shift-history',
    OPERATOR_CURRENT_LAST = 'shift-history/current-and-last-shift',
    SERVICE_IQR = 'service-iqr',
    SERVICE_IQR_LIST = 'service-iqr/total',
    VISIBILITY_LOGGING_CONFIG = 'visibility-logging-config',
    CUSTOMER_NFC_SITE_TAG_CONFIG = 'customer-nfc-site-tag-config',
    EVENT_CLASSIFICATION_CONFIG = "signal-influx-classification-type",
    ZONE_SUSPEND_OCCURRENCE_BOOK = 'zone-suspend/occurrence-book',
    GROUP_MESSAGES = 'group-message/message-history',
    UX_GROUP_MESSAGES = 'ux/supervisor-message-group-type',
    GROUP_MESSAGES_POST = 'group-message',
    ZONE_SUSPEND_LIST = 'zone-suspend/Details',
    ZONE_SUSPEND_POST = 'zone-suspend/customer',
    ZONE_SUSPEND_POST_API = 'zone-suspend/occurrence-book-signal',
    EVENT_INSTRUCTOR_INSTRUCTIONS = "instructor-instructions",
    EVENT_INSTRUCTOR_INSTRUCTIONS_DROPDOWN = "ux/instructor-instruction-types",

    UX_ALARM_TYPE_DROPDOWN = "ux/alarm-type-with-description",
    UX_INCIDENT_DROPDOWN = "ux/incident",
    UX_CUSTOMER_TYPE_OPTIONS = 'ux/customer-option',

    EVENT_INSTRUCTOR_INSTRUCTIONS_TRIGGER_DROPDOWN = "instructor-instruction-trigger-types",
    CUSTOMER_CATEGORIES_FOR_CUSTOMER = "customer-categories-customer-address",
    CUSTOMER_CATEGORIES = "customer-categories",
    CUSTOM_CATEGORIES_DROPDOWN = "ux/custom-category-config/value-restriction",
    CUSTOM_CATEGORIES_LIST_ITEM = "ux/custom-category-list-item",
    WELCOME_PATROL = "welcome-patrol",

    RISK_WATCH = "risk-watch",
    UX_RISK_WATCH_STOCK_ID = "ux/stock-id",
    UX_RISK_WATCH_SITE_TYPES = "ux/site-types",
    EMAIL_DISTRIBUTION = "email-distribution",


    OCCURRENCE_BOOK_MEMO_ID = 'occurrence-book/id',
    OCCURRENCE_BOOK_MEMO_POST = 'occurrence-book-memo',
    SUPERVISOR_ALERT_RECALL = 'supervisor-alert/recall',

    UX_ERB_TEMPLATE = 'erb/ux/template',
    UX_ERB_YEAR = 'erb/finacialyear',
    UX_OCCURENCE_MONTH = 'erb/ux/occurrence-month',
    UX_NOTIFY_CLIENT = 'erb/ux/notify-client',
    ERB_NOTIFICATION_SHOW = 'erb/show',
    ERB_NOTIFICATION_BILLING_SHOW = 'erb-billing/show',
    ERB_NOTIFICATION_SHOW_DETAILS = 'erb/showdetail',
    ERB_NOTIFICATION = 'erb/notification',
    ERB_BILLING_NOTIFICATION_DETAILS = 'erb-billing/notification-details',
    ERB_BILLING_SHOW = 'erb-billing/show',
    ERB_BILLING_SHOW_DETAILS = 'erb-billing/showdetail',
    ERB_BILLING_INVOICE = 'erb-billing-invoice',
    ERB_BILLING_INVOICE_RESEND_SMS = 'erb-billing-invoice/resend-sms',
    UX_TEMPLATE = 'ux/template',
    ERB_UX_OCCURENCE_MONTH = 'erb/ux/occurrence-month',
    CLIENT_ASSISTENCE = 'supervisor-request',
    ERB_SUMMARY = 'erb-summary',
    ERB_SUMMARY_DETAILS = 'erb-summary/details',
    COORDINATOR_CALL_LIST = 'calls/coordinator-call-history',
    UX_SIGNAL_MANAGEMENT_THIRD_PARTY_CONFIG_BRANCH = 'ux/signal-management/third-party-config/branch',
    UX_SIGNAL_MANAGEMENT_THIRD_PARTY_config_misc_origin = 'ux/signal-management/third-party-config/misc-origin',
    VIEW_OF_AUDIT = 'customer-account/audit',
    DECODER_HISTORY = 'customer-account/decoder-history',

    VEHICAL_MODEL = 'ux/vehicle-model',
    VEHICAL_MAKE = 'ux/vehicle-make',
    VEHICAL_COLOR = 'ux/vehicle-color',
    VEHICAL_SHAPE = 'ux/vehicle-shape',
    VEHICAL_COLORS = 'vehicle-color',
    UX_SIGNAL_MANAGEMENT_THIRD_PARTY_TYPES = 'ux/signal-management-third-party-types',
    OCCURENCE_BOOK_REPORT_DROPDOWN = 'ux/occurrence-book/list-report/static-column',
    OCCURENCE_BOOK_REPORT_LIST = 'occurrence-book/list-report/template',
    TECHNICIAN_INCENTIVES = 'signal-management/team-leader-technician/incentives',
    TECH_REVENUE = 'tech-revenue',
    PHONE_CALL_FEEDBACK = 'phone-call-feedback',
    THIRD_PARTY_RESPONSE = 'third-party-response',
    THIRD_PARTY_RESPONSE_DROPDOWN = 'ux/third-party-response',
    SIGNAL_MANAGEMENT_THIRD_PARTY_CONFIG_id = 'signal-management/third-party-config/id',
    SIGNAL_MANAGEMENT_CONFIG_PERCENTAGE = 'signal-management-config/Taxid',
    UX_SIGNAL_MANAGEMENT_THIRD_PARTY_CONFIG_DIVISION = 'ux/division/siganl-management-third-party',
    UX_SIGNAL_MANAGEMENT_THIRD_PARTY_CONFIG_BRANCHS = 'ux/branch/siganl-management-third-party',
    UX_PARTITION_NUMBER = 'ux/partition-number',
    CUSTOMER_ACCOUNT_PARTITION = 'customer-account-partition',
    BOUNDRY_ALLOCATION = 'customer-boundary-allocation/details',
    ACTIVE_STACK_VIEW = 'active-stack-view',
    ON_HOLD_STACK_VIEW = 'phoner-stack-view/onhold',
    DISPATCHER_MAP_VEHICLE_DETAILS = 'dispatcher-map-vehicle-details',
    VEHICLE_OCCURRENCE_BOOK_DETAILS = 'dispatcher-map-vehicle-occurrencebook-details',
    VEHICLE_REASSIGN = 'occurrence-book-response-officer-vehicle/other/reassign',
    VEHICLE_REDIRECT = 'occurrence-book-response-officer-vehicle/other/redirect',
    RESPONSE_OFFICER_CHAT = 'response-officer-chat',
    VEHICLE_CANCELLED = 'occurrence-book-response-officer-vehicle/other/cancelled',
    VEHICLE_DESPATCHED = 'occurrence-book-response-officer-vehicle/other/dispatched',
    VEHICLE_MAKE_AVAILABLE = 'occurrence-book-response-officer-vehicle/other/available',
    UX_RO_AVAILABLE = 'ux/dispatcher-map-ro-available',
    UX_OCCURRENCE_BOOK = 'ux/dispatcher-map-occurrencebook',
    // DISPATCHER_MAP_OCCURRENCE_BOOK_DETAILS='dispatcher-map-occurrencebook-details',
    SPIKE_IDETIFICATION_CONFIG = 'spike-identification/list',
    UX_SPIKE_IDENTIFICATION = 'ux/spike-identification-window-periods',
    SIGNAL_PATTERN = 'signal-pattern',
    DISPATCHER_MAP_OCCURRENCE_BOOK_DETAILS = 'dispatcher-map-occurrencebook-details',
    DISPATCHER_MAP_PATROL_DETAILS = 'dispatcher-map-Patrol-details',
    SPIKE_IDETIFICATION_CONFIG_POST = 'spike-identification',
    UX_VEHICLE_DROPDOEN = 'ux/vehicle-type',
    OCCURENCE_BOOK_PHONER_INTERACTION_CHECK = 'instructor-instructions-needto-acknowledge-check/occurrence-book',
    //OCCURENCE_BOOK_PHONER_INTERACTION_CHECK = 'occurrence-book/phoner-interaction-check',
    INSTRUCTOR_INSTRUCTIONS_ALARMTYPE = 'instructor-instructions-alarmtype',
    OCCURRENCE_BOOK_ACKNOWLEDGEMENT_PHONER_INTERACTION = 'occurrence-book/acknowledgement/phoner-interaction',
    CODE_50_ENABLE = "occurrence-book-incident-type/customer-address/code50/exists",
    UNDEFINED_SIGNALS = 'unknown-signal-config',
    PTT_STACK_AREA_CONFIG = 'ptt-stack-area-config',
    UX_RACE = 'ux/race',
    UX_GENDER = 'ux/gender',
    CAMERA_PROFILE_SEARCH = 'ux/camera-profile-customer',
    LSS_REGISTRATION = 'ux/lss-registration',
    SIGNAL_INFLUX = 'signal-influx',
    CLASSIFICATION_TYPES = 'ux/signal-influx-classification-type',
    CAMERA_PROFILE = 'camera-profile',
    CUSTOMER_MESSAGING_GROUP = 'customer-messaging-group',
    CUSTOMER_MESSAGINGGROUP = 'customer-messagingGroup',
    CUSTOMER_MESSAGIN_GROUP_HISTORY = 'occurrence-book-customer-messaging',
    CANCEL_PATROL_COMMON = 'active-patrol-cancel',
    ACTIVE_PATROL_CUSTOMERS = 'active-patrol-customers',
    RESPONSE_OFFICER_RO_LIST = 'occurrence-book-response-officer-vehicle/ro-list',
    STACK_UX_CUSTOMER_TYPE = 'ux/customer-profile-type',
    UX_RESPONSE_OFFICER_DISPATCHER_SEARCH = 'ux/response-officer-current-log/dispatcher/search',
    PATROL_EDIT_COMMON = 'active-patrol-edit',
    RESPONCE_OFFICER_LOGOUT = 'response-officer-current-log-force-logout',
    OPEN_AREA_REASON = 'open-area-reason',
    WEATHER_PATTERN = 'weather-pattern',
    MAP_MONITORING_CUSTOM = 'map-monitoring/custom',
    MAP_MONITORING_LAYER = 'map-monitoring/layer',
    UX_MAP_VIEW_LAYER_TYPES = 'ux/map-view-layer-type',
    MAP_MONITORING_USER = 'map-monitoring/user',
    SPICK_IDENTYFICATION_ACTIIVE = 'spike-identification-active',
    AUTO_DISPACH_EXPORT = 'response-officer-current-log-export',
    UX_ALARM_TYPE_DESCRIPTION_SIGNAL = "ux/alarm-type-with-description",
    CUSTOMER_SIGNAL_HISTORY = 'occurrence-book/customer-address',
    PHONER_STACK_SIGNAL_COUNT = "phoner-stack-view/emergency-non-emergency-count",
    DISPACHER_STACK_SIGNAL_COUNT = "dispatcher-stack-view/emergency-non-emergency-count",
    UX_OPEN_AREA_REASON = "ux/open-area-reason",
    HOLIDAY_TEMP_INSTRUCTION_DETAILS = 'holiday-instruction/details',
    HOLIDAY_TEMP_INSTRUCTION_ESCALATION = 'occurrence-book/request-dispatch',
    UX_QUERY_BUILDER_CONFIG_DROPDOWN = 'ux/query-builder-config-tables',
    UX_QUERY_BUILDER_CONFIG_COLUMN = 'ux/query-builder-config-columns',
    GET_FINDU_DETAILS = 'findu-user/occurrence-book',
    GET_PANIC_DETAILS = 'panic-app-user/occurrence-book',
    STACK_MONITORING_DISPATCHER = 'stack-monitoring/dispatcher',
    STACK_MONITORING_PHONER = 'stack-monitoring/phoner',
    CUSTOMER_ACCOUNT_BOM = 'customer-account-bom',
    TECHNICAL_TESTING_TASK_LIST_DETAILS = 'technical-testing/task-list-details',
    TECHNICAL_TESTING_REQUEST_PASSOWRD_APPOVE = 'technical-testing/request-password-approve',
    GET_OCCURRENCE_BOOK_DETAILS = 'panic-app-user-detail/occurrence-book',
    CUSTOMER_ADDREDD_PARTIONID_STACK = 'customer-address-other-occurrence-book-partition',
    ZONE_SUSPEND_DELAY_MINS = 'zone-suspend/suspend-maxdelay-mins',
    SUPERVISOR_MESSAGE_READ_SITE = 'supervisor-message-read',
    KEY_HOLDER_CANCELLED = 'key-holder/cancelled',
    UX_NAMED_STACK_CONFIG_MAPPED = 'ux/named-stack-config-mapped',
    SHIFT_CHNAGING_DECLINED = 'shift-changing/declined',
    SHIFT_CHNAGING_APROVED = 'shift-changing/approved',
    REPROCESS_SIGNAL_AUTOMATED = 'occurrence-book-signal/reprocess',
    UX_SUB_SRES_COORDINATE = 'ux/sub-area-coordinate',
    UX_THIRD_PARTY_DETAILS_TYPE = 'ux/third-party-details-type/occurrence-book',
    UX_THIRD_PARTY_DETAILS_TYPE_CUSTOMER_ADDRESS = 'ux/third-party-details-type/customer-address',
    OUTBOUND_CALL_CONNECTED_LOG = 'open-scape/out-bound/call-log/call-connected',
    OUTBOUND_CALL_DISCONNECTED_LOG = 'open-scape/out-bound/call-log/call-disconnected',
    OUTBOUND_CALL_FAILED_LOG = 'open-scape/out-bound/call-log/call-failed',
    RESPONCE_OFFICER_AVAILABLE = 'occurrence-book-response-officer-vehicle/other/available',
    RESPONCE_OFFICER_REASSIGN = "occurrence-book-response-officer-vehicle/other/reassign",
    VEHICLE_SUB_AREA_TIMEON_EXTENDED = 'occurrence-book-response-officer-vehicle/other/timeextend',
    RESPONCE_OFFICER_AVAILABLE_ENABLE_AUTODISPCHE = 'response-officer-current-log-enable-autodispatch',
    // SIGNAL sPECIAL API
    UX_ALARM_TYPE_ALLOW_TAGGING = "ux/alarm-type-allow-tagging",
    //Client Alaram type Api
    UX_ALARAM_TYPE_CAN_PHONE_IN = "ux/alarm-type-can-phone-in",
    OFFICER_ASSISTANT_DISPACHER = 'ux/distress-location-type',
    RESPONCE_OFFICER_ASSISTANCE_GET = "response-officer-current-log-distress",
    DISTRESS_RESPONCE_OFFICER_OTHER = "distress/response-officer-by-other",
    NAMED_STACK_CUSTOMER_ADDRESS = 'customer-namedstack-mapping',
    OB_CALL_FEEDBACK_SUBMIT = 'occurrence-book-call-flow/call-feedback',
    CUSTOMER_NAMED_STACK_MAPPED = 'customer-namedstack-mapped',
    NAMED_STACK = 'named-stack',
    ZONE_EQUIPMENT_MAPPING_SERIAL_NUMBER = 'zone-equipment-mapping-serial-number',
    RESPONSE_OFFICER_CURRENT_LOG_ALREADY_LOGGED_IN = 'response-officer-current-log-already-logged-in',
    UX_RESPONSE_OFFICER_NOT_LOGGED_IN = 'ux/response-officer-not-logged-in',
    RO_MANUAL_LOGIN_BY_OTHER = 'ro-manual-login-by-other',
    VAS_MANAGER_DASHBOARD_SUMMARY = 'vas-manager-dashboard/summary',
    VAS_MANAGER_DASHBOARD_DIAL = 'vas-manager-dashboard/dial',
    UX_MINUTE = 'ux/minute',
    CUSTOMER_SIGNAL_HISTORY_ARCHIIVE = 'occurrence-book/archive/customer-address',
    CUSTOMER_ADDRESS_BOUNDARY_MAPPING = 'customer-address-boundary-mapping',
    UX_KEY_HOLDER_ADDRESS = 'ux/key-holder/customer-address',
    OCCURANCE_BOOK_FEEDBACK = 'occurrencebook-feedback-occurrencebook',
    OCCURANCE_BOOK_FEEDBACK_POST = 'occurrencebook-feedback',
    TECHNICAL_TESTING_STOP_MANUALLY = 'technical-testing/manually-stopped',
    ERB_VALIDATE_RUN = 'erb-validate-run',
    ERB_BILLING_VALIDATE_RUN = 'erb-billing-validate-run',
    THIRD_PARTY_DETAILS_USING_COORDINATES = 'ux/third-party-details-type/coordinate',
    ZONE_SUSPEND_CUSTOMER_ADDRESS = 'zone-suspend/customer-address',
    ZONE_SUSPEND_MANUALLY_STOPPED = 'zone-suspend/manually-stopped',
    UX_SITE_TYPES_CUSTOMER_PROFILE_TYPES = 'ux/site-types-customer-profile-types',
    ALARM_TYPE_DESCRIPTION_STACK_CONFIG = "ux/alarm-type-description-stack-config",
    DISPATCHER_STACK_VIEW_FEED_OCCURRENCE_BOOK_MIRROR = "dispatcher-stack-view-feed-occurrence-book-mirror",
    PHONER_STACK_VIEW_FEED_OCCURRENCE_BOOK_MIRROR = "phoner-stack-view-feed-occurrence-book-mirror"
}
